// @flow weak
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {PatientActions}  from '../reducers/patient/index'
import {
    Button,
    Col,
    Row,
    Icon,
    FormControl
} from '@sketchpixy/rubix'
import * as _ from 'lodash'
import moment from 'moment'
import FileSignGif from "../components/FileSignGif";
import SignaturePolicy from "../components/SignaturePolicy";
import NotificationSystem from 'react-notification-system';

var SignaturePad = require('react-signature-pad');

const MIN_PIXELS = 3000;

class Sign extends Component {
    constructor(props) {
        super(props)

        let currentDbq = this.props.location && this.props.location.currentDbq ? this.props.location.currentDbq : JSON.parse(sessionStorage.getItem('currentDbq'));
        let patient = this.props.location && this.props.location.patient ? this.props.location.patient: JSON.parse(sessionStorage.getItem("patient"));
        let questionState = this.props.location && this.props.location.questionState ? this.props.location.questionState : JSON.parse(sessionStorage.getItem("questionState"));

        this.state = {
            patient: patient,
            questions: questionState,
            currentDbq: currentDbq,
            file: props.location && props.location.file ? props.location.file : "",
            current:0,
            minWidth:2.0,
            maxWidth:3.0,
            fonts: [{font: "Meddon"}, {font: "Homemade Apple"}, {font: "Shadows Into Light"}, {font: "Permanent Marker"},{font: "Schoolbell"}, {font: "Yellowtail"}],
            signFlag: false,
            showSpinner: false,
            checkbox: false,
            showSignaturePolicy: false,
            showAutoSign: false,
            autoSignCount: 1,
            selectedFont: "Meddon"
        }
    }

    sigPad = {}

    clear = () => {
        if (!this.state.showAutoSign) {
            this.sigPad.clear()
            this.setState({signFlag:false, autoSignCount: this.state.autoSignCount+1})
        }
        // if (this.state.autoSignCount >=3) {
        //     this.setState({showAutoSign: true, signFlag:true})
        // }
    }

    toggleSignView = () => {
        if(this.state.showAutoSign) {
            this.setState({signFlag:false})
        } else {
            this.setState({signFlag:true})
        }
        this.setState({showAutoSign: !this.state.showAutoSign, autoSignCount: 1, signFlag: false, checkbox: false})
    }

    setSignFlag = () => {
        this.setState({ signFlag:true })
    }

    checkTerms = () => {
        if (!this.state.checkbox) {
            this._addNotification("Please accept DBQ Electronic Signature Acknowledgment", 'error', 'Error Message: ');
        }
    }

    loadSignaturePolicy = () => {
        this.setState({ showSignaturePolicy: true })
    }

    closeSignaturePolicy = () => {
        this.setState({ showSignaturePolicy: false })
    }

    actions = link => {
        const { location } = this.props;
        const {patient, questions, currentDbq, selectedFont, showAutoSign, checkbox } = this.state;

        this._notificationSystem.clearNotifications();

        if (this.state.signFlag) {
            if (showAutoSign && !checkbox) {
                this.checkTerms();
            } else {
                const { painted } = this._getSignatureStats();

                if (painted < MIN_PIXELS) {
                    this._addNotification(
                        `Your signature did not meet the minimum size requirement. Please sign again more fully.`,
                        'error',
                        'Signature Too Small'
                    );

                    return;
                }


                let image = this.sigPad && this.sigPad.toDataURL();
                this.setState({ showSpinner: true });
    
                let patientId = patient ? patient.id : '';
                sessionStorage.setItem('signedDbq', JSON.stringify({id: currentDbq.id, time: new Date().getTime()}))
                let requiredSignRecords = sessionStorage.getItem("requiredSignRecords") ? JSON.parse(sessionStorage.getItem("requiredSignRecords")) : [];
                if (requiredSignRecords && requiredSignRecords.length > 0) {
                    let records = []
                    records = _.filter(requiredSignRecords, function(o) { 
                        return o.dbqId !== currentDbq.id
                        }); 
                        sessionStorage.setItem("requiredSignRecords", JSON.stringify(records)) 
                }
                this.props.updatePatientSign(patientId, patient.name, currentDbq.name, currentDbq.id, patient.apptId, questions, image, "signed", null, patient.isPreviousVersion, selectedFont, moment().format('MM-DD-YYYY'), patient.ssn && patient.ssn.docDate && patient.ssn.docDate.dbqName);
                sessionStorage.removeItem("selectedLicense")
            }
        } 
    }

    goBack = link => {
        const { history, location } = this.props
        history.push({ pathname: link, currentDbq: this.state.currentDbq, patient: this.state.patient, questionState: this.state.questions, file: this.state.file })
    }

    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            position: 'tr',
            autoDismiss: 8
        })
    }

    _getSignatureStats = () => {
        const canvas = this.sigPad.refs.cv;
        if (!canvas) return { width: 0, height: 0, painted: 0, boxArea: 0 };
      
        const ctx = canvas.getContext('2d');
        const w   = canvas.width;
        const h   = canvas.height;
        const img = ctx.getImageData(0, 0, w, h).data;
      
        let minX = w, minY = h, maxX = 0, maxY = 0;
        let paintedCount = 0;
      
        for (let i = 0; i < img.length; i += 4) {
          if (img[i + 3] > 0) {         // alpha > 0 → painted
            paintedCount++;
            const idx = i / 4;
            const x = idx % w;
            const y = Math.floor(idx / w);
      
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      
        // no paint?
        if (paintedCount === 0) {
          return { width: 0, height: 0, painted: 0, boxArea: 0 };
        }
      
        const width   = maxX - minX;
        const height  = maxY - minY;
        const boxArea = width * height;
      
        return { width, height, painted: paintedCount, boxArea };
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
     
        let minWidthSet = [2.0, 2.5, 3.0];
        let maxWidthSet = [3.0, 3.5, 4.0];
        this.setState({minWidth : minWidthSet[Math.floor(Math.random() * Math.floor(3))]})
        this.setState({maxWidth : maxWidthSet[Math.floor(Math.random() * Math.floor(3))]})
    }

    componentWillReceiveProps(newProps) {
        //let { fetching, isPatientUpdate} = newProps
        // if (isPatientUpdate && !fetching) {
        //     localStorage.setItem('fetching', false);
        // }
        const { history } = this.props
        // const { history, location } = this.props
        // localStorage.setItem("signedPatientId", location.patient? location.patient.id : '')
        // let alreadySignedDbq = localStorage.getItem("signedDbq") ? localStorage.getItem("signedDbq") : '';
        // signedDbqs.push(alreadySignedDbq +","+ this.state.patient.disabilityName.toLowerCase())
        // localStorage.setItem("signedDbq", this.state.patient ? alreadySignedDbq +","+ this.state.patient.disabilityName.toLowerCase(): '')

        
        this.interval = setTimeout(() => {
            //this.setState({showSpinner: false});
            //history.push({pathname:'/admin/confirmPatient', state: this.state.patient, patient: location && location.patient, doneDisability: this.state.patient && this.state.patient.disabilityName})
            
        // let signedLocalDbqs = localStorage.getItem('signedDbqs') ? JSON.parse(localStorage.getItem('signedDbqs')): '';
        const {patient } = this.state
            if (patient && patient.disabilities) {
                let totalDBQs = patient.disabilities.length;
                let totalSignedDBQs = 0;
                for (let i=0; i< totalDBQs; i++) {
                    if (patient.disabilities[i].isSigned) {
                        totalSignedDBQs ++;
                    }
                }
                if (totalDBQs === totalSignedDBQs) {
                    // history.push({pathname:'/admin/dashboard', isSign: true})
                    let currentPath = window.location.pathname;
                    history.replace(`${currentPath}/admin/dashboard`);
                } else {
                    history.push({pathname:'/admin/confirmPatient', isSign: true})
                }
            
            } else {
                let src = sessionStorage.getItem('src') ? sessionStorage.getItem('src'): ""

                history.push({pathname:'/admin/dashboard', isSign: true})
            }
        }, 5000);
    }

    signLater = () => {
        const { history } = this.props
        
        const { patient, questions, current, totalQuestion, currentDbq } = this.state;
        // let patient = JSON.parse(localStorage.getItem('patient'));
        let body = {
            id: patient && patient.id ? patient.id : '',
            dbq: currentDbq.name,
            questions: questions,
            ssn: null,
            status: 'signLater',
            patientName: patient.name
        }

        let token = localStorage.getItem('login_token');
        let headers = {'Content-Type': 'application/json'};
        headers["Authorization"] = `Bearer ${token}`
        let url = process.env.API_URL+"/patients/"+patient.id
        
        let method = "PUT";
        fetch(url, {method: method, body: JSON.stringify(body), headers} )
        .then(response => response.json())
        .then(data => {
                history.push({pathname:'/admin/dashboard'})
        })
        .catch(err => {
            this.setState({fetching: false})
            console.error(err)
        });

        //this.props.updatePatientSign(patientId, patientName, currentDbq.name, currentDbq.id, patient.apptId, questions, image, "signed", allDbqsDone);

        //history.push({pathname:'/admin/dashboard', isSign: false})
        //let patient = localStorage.getItem('patient') ? JSON.parse(localStorage.getItem('patient')): '';
        // if (patient && patient.disabilities) {
        //     let totalDBQs = patient.disabilities.length;
        //     let totalSignedDBQs = 0;
        //     for (let i=0; i< totalDBQs; i++) {
        //         if (patient.disabilities[i].isSigned) {
        //             totalSignedDBQs ++;
        //         }
        //     }
        //     //this.props.updatePatientSign(patientId, patientName, currentDbq.name, currentDbq.id, patient.apptId, questions, image, "signed", allDbqsDone);
        //     //if (totalDBQs-1 === totalSignedDBQs) {
        //         history.push({pathname:'/admin/dashboard', isSign: false})
        //     // } else {
        //     //     history.push({pathname:'/admin/confirmPatient', isSign: false})
        //     // }
        // } else {
        //     history.push({pathname:'/admin/dashboard', isSign: false})
        // }
    }

    selectStyle = (font) => {
        this.setState({selectedFont: font})
    }

    render() {
        const { showAutoSign} = this.state

        let patient = JSON.parse(sessionStorage.getItem('patient'))

        let docName = patient && patient.doctorsInfo && patient.doctorsInfo.name ? patient.doctorsInfo.name : patient && patient.ssn && patient.ssn.docName ? patient.ssn.docName.value : "";
        let docNpi  = patient && patient.doctorsInfo && patient.doctorsInfo.npi ? patient.doctorsInfo.npi : patient && patient.ssn && patient.ssn.docNpi ? patient.ssn.docNpi.value : "";

        return (
            <div className="show-with-ease">
                <NotificationSystem ref='notificationSystem' />
                <Row>
                    <Col smOffset={4} sm={4} className="text-center">
                        <h1 className="heading-main" style={{marginTop: 0}}>
                            <strong>Sign DBQ</strong>
                        </h1>
                        <h5 style={{margin: '5px'}}>
                            <strong>Name: </strong>{docName}
                        </h5>
                        <h5 style={{margin: '5px'}}>
                            <strong>NPI: </strong>{docNpi}
                        </h5>
                    </Col>
                    
                    <Col sm={3} style={{paddingTop: 20}}>
                        {/* below button is commented on 09/28/2022 */}
                        {/* <span style={{marginLeft: -15}}>
                            <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                style={{backgroundColor: '#022144', borderColor: '#022144', boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)'}}
                                className="big-btn"
                                onClick={e => this.signLater()}
                            ><Icon style={{marginRight: '10px'}}
                            glyph='glyphicon glyphicon-pencil'/>
                            Sign Later  
                            </Button>
                        </span> */}
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} smOffset={1} sm={10}>
                        <div style={{width: '650px',margin: '10px auto'}}>
                        <table className="table table-responsive" style={{marginBottom: 0}}>
                            <tbody>
                            <tr>
                                {showAutoSign && <td width="10%" style={{borderTop: 0}}>
                                    <label className="radio-right-innerbox-label" >
                                    <FormControl 
                                        type="checkbox"
                                        key={"radioFieldTiles"}
                                        name="radioFieldTiles" 
                                        checked={this.state.checkbox}
                                        value="signBox"
                                        style={{cursor: 'pointer'}}
                                        onClick={() => { this.setState({ checkbox: !this.state.checkbox });}}
                                        label="Enter value" /> 
                                    </label>
                                </td> }
                                {showAutoSign && <td width="70%" style={{borderTop: 0}} onClick={() => { this.setState({ checkbox: !this.state.checkbox });}}>
                                    <h4 style={{cursor: 'pointer', color: '#022144'}}><b>I agree</b></h4>
                                </td>}
                                
                                {!showAutoSign && <td width="70%" style={{borderTop: 0}}>
                                    <h4 style={{cursor: 'pointer', color: '#022144'}}><b>By signing below, you agree to the <span style={{textDecoration: 'underline'}} onClick={this.loadSignaturePolicy}>DBQ Signature Acknowledgment</span></b></h4>
                                </td>}
                                {/* <td style={{textAlign: 'right'}}>
                                    <span style={{fontSize: '20px', fontWeight:'bold', color: '#079EDA', cursor: 'pointer', }} onClick={this.clear}>Clear<Icon style={{marginLeft: '10px', fontSize: '18px'}} glyph='glyphicon glyphicon-repeat'/></span>                        
                                </td> */}
                            </tr>
                            </tbody>
                        </table>
                        </div>
                        {showAutoSign && <div style={{width: '90%', marginLeft: '2%', textAlign: 'justify'}}>
                                    <h5 style={{color: '#022144'}}>By selecting “I agree”, I acknowledge that I am signing this DBQ electronically and agree to the terms of the <span style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={this.loadSignaturePolicy}><b>DBQ Signature Acknowledgment</b></span>. I understand and agree that the selected electronic signature style is as valid and has the same legal effect and equivalence as if I had signed manually with my handwritten signature.</h5>
                            </div>}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} smOffset={1} sm={10} >                        
                        {/* <div className='signature-pad' onClick={() => { this.checkTerms()}}> */}
                        
                        {!showAutoSign ? <div className='signature-pad'>
                            {/* <div className={!this.state.checkbox ? "signature-overlay" : ""}></div> */}
                                <SignaturePad
                                velocityFilterWeight="0.7" 
                                minWidth = {this.state.minWidth}
                                maxWidth = {this.state.maxWidth}
                                dotSize="3.0"
                                onEnd={this.setSignFlag }
                                ref={(ref) => { this.sigPad = ref }}/>
                            </div>
                            :
                            <div style={{position: 'relative', height: 'auto', margin: '0 auto', textAlign: 'center'}}>
                                <div className='row col-sm-12' >
                                    {
                                        this.state.fonts && this.state.fonts.slice(0, 3).map((f, i) => {
                                            return (
                                                <div key={i} className='col-sm-4' onClick={e => {this.selectStyle(f.font)}} style={{fontFamily: f.font, fontSize: 20, color: 'rgb(2, 33, 68)', fontWeight: 'bold', padding:5}}><p className='font-card' style={this.state.selectedFont === f.font ? {borderRadius: 8, borderTop: '5px solid #079EDA', padding: 23, cursor: 'pointer'}: {padding: '26px 5px', cursor: 'pointer'}}>{docName}</p></div>
                                            )
                                        })
                                    }
                                    </div>
                                    <div className='row col-sm-12'>
                                    {
                                        this.state.fonts && this.state.fonts.slice(3, 6).map((f, i) => {
                                            return (
                                                <div key={i+20} className='col-sm-4' onClick={e => {this.selectStyle(f.font)}} style={{fontFamily: f.font, fontSize: 20, color: 'rgb(2, 33, 68)', fontWeight: 'bold', padding:5}}><p className='font-card' style={this.state.selectedFont === f.font ? {borderRadius: 8, borderTop: '5px solid #079EDA', padding: 23, cursor: 'pointer'}: {padding: '26px 5px', cursor: 'pointer'}}>{docName}</p></div>
                                            )
                                        })
                                    }
                                </div>
                            </div>}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} smOffset={1} sm={10}>
                        <div style={{width: '650px',margin: '10px auto'}}>
                        <table className="table table-responsive" style={{marginBottom: 0}}>
                            <tbody>
                            <tr>
                                <td width="80%" style={{borderTop: 0}}>
                                { showAutoSign ?<span style={{fontSize: '20px', fontWeight:'bold', color: '#079EDA', cursor: 'pointer', }} onClick={e => {this.toggleSignView()}}>Signature Pad</span>: null}
                                </td>
                                <td style={{textAlign: 'right', borderTop: 0}}>
                                { !showAutoSign ? <span style={{fontSize: '20px', fontWeight:'bold', color: '#079EDA', cursor: 'pointer', }} onClick={this.clear}>Clear<Icon style={{marginLeft: '10px', fontSize: '18px'}} glyph='glyphicon glyphicon-repeat'/></span>: null}                        
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </Col>
                </Row>
                

                {this.state.showSpinner && <FileSignGif/>}
                {this.state.showSignaturePolicy && <SignaturePolicy onClose={e => this.closeSignaturePolicy()} />}
                <Row className="button-bottom" style={{ bottom: 0, marginBottom: 15 }}>
                    <Col sm={6} collapseLeft collapseRight className='text-right button-bottom'>
                        <Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="back-btn big-btn"
                            onClick={this.goBack.bind(this, "/admin/dbq")}
                        >Back<span className="backiconspan"><svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.48866 0L9.97699 1.7625L4.08699 8.75H16.9331V11.25H4.08699L9.97699 18.2375L8.48866 20L0.0442162 10L8.48866 0Z" fill="#797979"/>
                        </svg>
                        </span></Button>
                    </Col>
                    <Col sm={6} collapseLeft collapseRight
                        className='text-left button-bottom'>
                        <Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="complete-exam-btn big-btn"
                            onClick={this.state.signFlag && this.actions.bind(this, "/admin/confirmPatient")}
                        >Complete Exam {this.state.signFlag ? <span className="nexticonspan arrow-animate"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z" fill="#fff"/>
                            </svg>
                            </span>: ''}
                        </Button>
                    </Col>
                </Row>
                {/* <Row style={{marginTop: 30}}>
                    <Col xs={12} smOffset={1} sm={10}>
                        <table className="table table-responsive">
                            <tr>
                                <td width="80%" style={{textAlign: 'center'}}>
                                <img className="img-hover-shadow" src="/imgs/app/Sign Later Button.svg" title="Sign Later" onClick={e => this.signLater()} />
                                </td>
                            </tr>
                        </table>
                </Col>
                </Row> */}

            </div>
        )
    }
}


const mapStateToProps = state => ({
    patient: {
        specific: {
            patientInfo, fetching, error, isPatientUpdate
        }
    },
  }) => {
   return {
    patientInfo,
    fetching,
    error,
    isPatientUpdate
   }
}

const mapDispatchToProps = dispatch => ({
    updatePatientSign: (id, patientName, dbq, dbqId, apptId, questions, image, status, accStatusChange,isPreviousVersion, font, doctorLocalDate, docDateDbqName) => {
        dispatch(PatientActions.updateSpecificPatientSignRequest({
            id,
            patientName,
            dbq,
            dbqId,
            apptId,
            questions,
            image,
            status,
            accStatusChange,
            isPreviousVersion,
            font,
            doctorLocalDate,
            docDateDbqName
        }))
    }
})


export default connect(mapStateToProps, mapDispatchToProps)(Sign)
